import moment from 'moment';

export const isDateBetweenMonthRange = (date: any, startMonth: number, endMonth: number): boolean => {
  const month = moment(date).month() + 1;
  return endMonth < startMonth
    ? (month >= (startMonth) && month <= 12) || month === (endMonth)
    : month >= (startMonth) && month <= (endMonth);
};

// Parses a date coming from the API. A non-empty but malformed string makes
// `new Date(...)` return an `Invalid Date` object (non-null, NaN timestamp),
// which callers would mistake for a real selected date — treat it as null.
export const toValidDateOrNull = (rawDate?: string | null): Date | null => {
  if (!rawDate) {
    return null;
  }
  const parsedDate = new Date(rawDate);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};
